import React, { useEffect, useState } from "react";
import { Button, Modal, Form } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { ReactSVG } from "react-svg";
import { Link, useHistory } from "react-router-dom";
import { DateTimeFormat, handleGetFileName } from "../../helpers/utils";
import moment from "moment";
import {
	createNotification,
	deleteNotification,
	fetchNotification,
	resetDeleteNotification,
	updateNofication,
	fetchStores,
} from "../../actions/notifications";
import NotificationForm from "../Forms/Notification";

const NotificationPage = () => {
	const { id } = useParams();
	const history = useHistory();
	const [form] = Form.useForm();
	const [file, setFile] = useState(null);
	const dispatch = useDispatch();
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [notificationId, setNotificationId] = useState(null);
	const { status, notification } = useSelector(
		(state) => state.fetchNotification,
	);
	const { status: updateStatus } = useSelector(
		(state) => state.updateNotification,
	);
	const { notificationDeleted } = useSelector(
		(state) => state.deleteNotification,
	);
	const { stores, loading: storeLoading } = useSelector(
		(state) => state.fetchStores,
	);

	const [screenState, setScreenState] = useState();
	const [type, setType] = useState("general");

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
		form.resetFields();
		setNotificationId(null);
		setFile(null);
		setScreenState(null);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
		form.resetFields();
		setNotificationId(null);
		setFile(null);
		setScreenState(null);
	};

	const handleEdit = () => {
		showModal();
		const newFile = notification.image
			? handleGetFileName(notification.image)
			: null;
		setNotificationId(notification.id);
		if (
			[
				"category",
				"survey category",
				"products",
				"product",
				"review",
				"webview",
			].includes(notification.path_to.screen)
		) {
			setScreenState(notification.path_to.screen);
		} else {
			setScreenState();
		}
		setType(notification.type);
		form.setFieldsValue({
			...notification,
			send_at: moment(notification.send_at).utcOffset("+08:00"),
			start_time: moment(notification.start_time).utcOffset("+08:00"),
			end_time: moment(notification.end_time).utcOffset("+08:00"),
			file: { fileList: newFile },
			screen: notification.path_to.screen,
			path_to_id: notification.path_to.id,
			store_ids: notification.store_ids,
		});
		notification.image && setFile([newFile]);
	};

	const handleDelete = () => {
		dispatch(deleteNotification(notificationId));
	};

	const handleSubmitForm = (values) => {
		const newValues = { ...values };
		newValues.file = file && !file[0].url ? file[0] : null;
		if (values.send_at)
			newValues.send_at = moment(values.send_at).format("DD/MM/YYYY HH:mm");

		if (values.start_time && values.end_time) {
			newValues.start_time = moment(values.start_time).format(
				"DD/MM/YYYY HH:mm",
			);
			newValues.end_time = moment(values.end_time).format("DD/MM/YYYY HH:mm");
		}

		newValues.path_to = {
			screen: values.screen,
			id: values.path_to_id ? values.path_to_id : null,
		};
		delete newValues.screen;
		delete newValues.path_to_id;
		if (notificationId) {
			dispatch(updateNofication(notificationId, newValues));
		} else {
			dispatch(createNotification(newValues));
		}
		handleOk();
	};

	const handleDisplayStores = (storesValue) => {
		const result = [];
		storesValue?.forEach((item) => {
			stores?.forEach((item2) => {
				if (item2.id === item) {
					result.push(item2.name);
				}
			});
		});
		return result?.join(", ");
	};

	useEffect(() => {
		if (id) {
			dispatch(fetchNotification(id));
			dispatch(fetchStores({}));
		}
	}, [id]);

	useEffect(() => {
		if (updateStatus === "SUCCEEDED") dispatch(fetchNotification(id));
	}, [updateStatus]);

	useEffect(() => {
		if (notificationDeleted) {
			history.push("/notifications");
			dispatch(resetDeleteNotification());
		}
	}, [notificationDeleted]);

	useEffect(() => {
		if (notification && notification.id === Number(id)) {
			setNotificationId(notification.id);
		} else {
			setNotificationId();
		}
	}, [notification]);

	return (
		<div className="details-container">
			<div className="page-header">
				<h2 className="page-header-title">Notification Details</h2>
			</div>
			<div className="page-header-details-actions">
				<div className="left">
					<Link to="/notifications">
						<Button type="link" className="btn btn-back">
							<ReactSVG src="/icons/arrow-left.svg" />
							Back
						</Button>
					</Link>
				</div>
				<div className="right">
					<Button
						type="primary"
						className="btn-primary"
						onClick={() => handleEdit()}
					>
						Edit
						<ReactSVG src="/icons/edit.svg" />
					</Button>
					<Button className="btn btn-danger" onClick={() => handleDelete()}>
						Delete
						<ReactSVG src="/icons/delete-all.svg" />
					</Button>
				</div>
			</div>
			{status === "SUCCEEDED" && (
				<div className="page-content">
					<div className="page-details-section">
						<div>
							<div className="box">
								<div className="box-header">
									<h2 className="box-title">Details</h2>
								</div>
								<div className="box-content">
									<div className="details-item">
										<label>Title</label>
										<div className="text" style={{ textTransform: "initial" }}>
											{notification.title}
										</div>
									</div>
									<div className="details-item">
										<label>Target Group</label>
										<div
											className="text"
											style={{ textTransform: "capitalize" }}
										>
											{notification.target_group}
										</div>
									</div>
									<div className="details-item">
										<label>Path to</label>
										<div className="text">
											<p className="text-capitalize">
												{notification.path_to.screen}
											</p>
											<p
												className={
													notification.path_to.screen !== "webview" &&
													"text-capitalize"
												}
											>
												{notification.path_to.id}
											</p>
										</div>
									</div>
									<div className="details-item">
										<label>Type</label>
										<div className="text text-capitalize">
											{notification.type}
										</div>
									</div>

									{notification.type === "store" ? (
										<>
											{notification?.start_time && (
												<div className="details-item">
													<label>Start Time</label>
													<div className="text">
														{DateTimeFormat(notification?.start_time)}
													</div>
												</div>
											)}
											{notification?.end_time && (
												<div className="details-item">
													<label>End Time</label>
													<div className="text">
														{DateTimeFormat(notification?.end_time)}
													</div>
												</div>
											)}
											{notification?.store_ids && (
												<div className="details-item">
													<label>Stores</label>
													<div className="text">
														{handleDisplayStores(notification?.store_ids)}
													</div>
												</div>
											)}
										</>
									) : (
										<div className="details-item">
											<label>Send At</label>
											<div className="text">
												{DateTimeFormat(notification.send_at)}
											</div>
										</div>
									)}
									<div className="details-item">
										<label>Idle Time</label>
										<div className="text">
											<p>{notification.idle_period}</p>
										</div>
									</div>
									<div className="details-item">
										<label>Description</label>
										<div className="text">
											<p>{notification.description}</p>
										</div>
									</div>
									{notification.image && (
										<div className="details-item">
											<label>Image</label>
											<div className="text">
												<div className="image-wrapper">
													<img src={`${notification.image}`} alt="image" />
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
			<Modal
				className="spin-form-modal"
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
			>
				<NotificationForm
					form={form}
					notificationId={notificationId}
					handleSubmitForm={handleSubmitForm}
					handleCancel={handleCancel}
					file={file}
					setFile={setFile}
					screenState={screenState}
					setScreenState={setScreenState}
					stores={stores}
					storeLoading={storeLoading}
					setType={setType}
					type={type}
				/>
			</Modal>
		</div>
	);
};

export default NotificationPage;
